import _ from "lodash/fp";

export const isFilled = (...paths) =>
    obj => _
      .at(paths, obj)
      .join("")
      .length > 0;